import { AiChatController } from '../controller/AiChatController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class AiChatWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AiChatController,
    });
  }
}
